export const useUniformTime = () => {
  const uTime = {
    value: 0,
  }

  const { onLoop } = useRenderLoop()

  onLoop(({ elapsed }) => {
    uTime.value = elapsed
  })

  return uTime
}
